import {
	devApiClientId,
	devFrontendClientId,
	prodApiClientId,
	prodFrontendClientId,
	awsProdHostName,
	testApiClientId,
	testFrontendClientId,
	awsTestHostName,
	azureTestHostName,
	azureProdHostName,
} from '~src/authconfig';

export const getClientId = () => {
	switch (window.location.hostname) {
		case 'localhost':
			return devFrontendClientId;
		case awsTestHostName:
		case azureTestHostName:
			return testFrontendClientId;
		case awsProdHostName:
		case azureProdHostName:
			return prodFrontendClientId;
		default:
			throw new Error('unrecognized domain');
	}
};

export const devProtectedResources = {
	overrides: {
		endpoint: 'http://localhost:4000/overrides',
		scopes: {
			read: [`api://${devApiClientId}/Overrides.Read`],
			write: [`api://${devApiClientId}/Overrides.Write`],
		},
	},
};

export const testProtectedResources = {
	overrides: {
		endpoint: `http://${awsTestHostName}/overrides`,
		scopes: {
			read: [`api://${testApiClientId}/Overrides.Read`],
			write: [`api://${testApiClientId}/Overrides.Write`],
		},
	},
};

export const prodProtectedResources = {
	overrides: {
		endpoint: `https://${awsProdHostName}/overrides`,
		scopes: {
			read: [`api://${prodApiClientId}/Overrides.Read`],
			write: [`api://${prodApiClientId}/Overrides.Write`],
		},
	},
};

export const getProtectedResources = () => {
	switch (window.location.hostname) {
		case 'localhost':
			return devProtectedResources;
		case awsTestHostName:
		case azureTestHostName:
			return testProtectedResources;
		case awsProdHostName:
		case azureProdHostName:
			return prodProtectedResources;
		default:
			throw new Error('unrecognized domain');
	}
};
